(() => {
  'use strict';
  const root = document.querySelector('[data-sales-preview-access]');
  if (!root) return;
  const productOps = 'https://product-ops.kind-of-blu.com';
  const requestedPublication = new URL(location.href).searchParams.get('publication');
  if (root.dataset.linkedPreviewOnly === 'true') {
    if (!/^sp_[a-f0-9-]{36}$/.test(requestedPublication || '')) return;
    root.classList.add('is-selected-preview');
    const commerce = document.querySelector('[data-sales-commerce]');
    if (commerce) { commerce.hidden = true; commerce.style.display = 'none'; }
  }
  // A URL selects a version only. The signed session and server grant check
  // below still decide access; it cannot expose an arbitrary publication.
  const publication = /^sp_[a-f0-9-]{36}$/.test(requestedPublication || '') ? requestedPublication : root.dataset.publication || '';
  const status = root.querySelector('[data-sales-access-status]');
  const controls = root.querySelector('[data-sales-access-controls]');
  const frame = root.querySelector('[data-sales-access-frame]');
  const login = root.querySelector('[data-sales-access-login]');
  const tools = root.querySelector('[data-sales-access-tools]');
  const locale = root.querySelector('[data-sales-access-locale]');
  const state = root.querySelector('[data-sales-access-state]');
  const params = new URL(location.href).searchParams;
  const discoveryScene = ['miss', 'hit001', 'hit002'].includes(params.get('discovery')) ? params.get('discovery') : 'miss';
  const language = ['zh-CN', 'en', 'ja'].includes(params.get('locale')) ? params.get('locale') : /^zh/i.test(document.documentElement.lang) ? 'zh-CN' : /^ja/i.test(document.documentElement.lang) ? 'ja' : 'en';
  const words = {
    'zh-CN': { title: 'Sales · 受控预览', loading: '正在核实店铺账号与预览权限…', ready: '这是已冻结版本的私有预览，暂不开放购买。', closed: '这期预览尚未开放。', denied: '当前账号无法查看这期预览。请确认已登录获邀账号。', retry: '连接暂时未完成，请刷新页面重试。', login: '登录店铺账号', locale: '语言', state: '模拟状态', active: '浏览', needLogin: '需登录', paused: '暂停', ended: '结束', payment: '付款处理中' },
    en: { title: 'Sales · Private preview', loading: 'Checking your store account and preview access…', ready: 'This private preview uses the frozen version. Purchasing is unavailable.', closed: 'This preview is not open yet.', denied: 'This account cannot view the preview. Sign in with an invited account.', retry: 'The connection could not be completed. Please refresh and try again.', login: 'Sign in to the store', locale: 'Language', state: 'Simulated state', active: 'Browsing', needLogin: 'Login required', paused: 'Paused', ended: 'Ended', payment: 'Payment pending' },
    ja: { title: 'Sales · 限定プレビュー', loading: 'ストアのアカウントと閲覧権限を確認しています…', ready: '確定したバージョンの限定プレビューです。購入はできません。', closed: 'このプレビューはまだ公開されていません。', denied: 'このアカウントには閲覧権限がありません。招待されたアカウントでログインしてください。', retry: '接続できませんでした。ページを更新して再度お試しください。', login: 'ストアにログイン', locale: '言語', state: 'シミュレーション状態', active: '閲覧', needLogin: 'ログインが必要', paused: '一時停止', ended: '終了', payment: '決済確認中' },
  };
  const labels = words[language];
  const toolsLabel = { 'zh-CN': '预览设置', en: 'Preview settings', ja: 'プレビュー設定' }[language];
  root.classList.add('kob-sales-preview-shell');
  document.documentElement.classList.add('kob-sales-preview-page');
  root.querySelector('[data-sales-access-title]').textContent = labels.title;
  for (const [node, key] of [[login, 'login'], [root.querySelector('[data-label-locale]'), 'locale'], [root.querySelector('[data-label-state]'), 'state']]) node.textContent = labels[key];
  for (const option of state.options) option.textContent = labels[{ login: 'needLogin', 'payment-pending': 'payment' }[option.value] || option.value];
  locale.value = language;
  if (['zh-CN','en','ja'].includes(params.get('locale'))) locale.value=params.get('locale');
  if (['active', 'login', 'paused', 'ended', 'payment-pending'].includes(params.get('state'))) state.value = params.get('state');
  const loginBase = login.getAttribute('href') || '/customer_authentication/login';
  const preserveLoginReturn = () => {
    // Follow KoB's existing Shopify return_url convention. Return only to this
    // page and its non-secret preview selectors, never a query-provided URL.
    const back = new URL(location.pathname, location.origin);
    if (/^sp_[a-f0-9-]{36}$/.test(publication)) back.searchParams.set('publication', publication);
    back.searchParams.set('locale', locale.value);
    back.searchParams.set('discovery', discoveryScene);
    back.searchParams.set('state', state.value);
    const url = new URL(loginBase, location.origin);
    url.searchParams.set('return_url', back.pathname + back.search);
    login.href = url.href;
  };
  preserveLoginReturn();
  const setToolsOpen = (expanded, restoreFocus = false) => {
    root.classList.toggle('tools-open', expanded);
    if (tools) {
      tools.setAttribute('aria-expanded', String(expanded));
      if (restoreFocus) tools.focus();
    }
  };
  if (tools) {
    tools.setAttribute('aria-label', toolsLabel);
    tools.setAttribute('title', toolsLabel);
    tools.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M9.8 3.4h4.4l.6 2.4 2.1 1.2 2.4-.7 2.2 3.8-1.8 1.7v2.4l1.8 1.7-2.2 3.8-2.4-.7-2.1 1.2-.6 2.4H9.8l-.6-2.4-2.1-1.2-2.4.7-2.2-3.8 1.8-1.7v-2.4L2.5 9.5l2.2-3.8 2.4.7 2.1-1.2.6-2.4Z"/><circle cx="12" cy="12" r="3.2"/></svg>';
    const toolText = document.createElement('span');
    toolText.className = 'kob-sales-access__tools-label';
    toolText.textContent = toolsLabel;
    tools.append(toolText);
    setToolsOpen(false);
    tools.addEventListener('click', () => setToolsOpen(!root.classList.contains('tools-open')));
    document.addEventListener('keydown', event => {
      if (event.key !== 'Escape' || !root.classList.contains('tools-open')) return;
      event.preventDefault();
      setToolsOpen(false, true);
    });
    document.addEventListener('pointerdown', event => {
      if (!root.classList.contains('tools-open') || tools.contains(event.target) || controls.contains(event.target)) return;
      setToolsOpen(false);
    });
    // Clicks inside the protected cross-origin canvas do not bubble here.
    // Focus entering its iframe still closes the parent settings overlay.
    window.addEventListener('blur', () => {
      if (document.activeElement === frame && root.classList.contains('tools-open')) setToolsOpen(false);
    });
  }
  status.textContent = labels.loading;
  const open = () => {
    preserveLoginReturn();
    const url = new URL('/sales/preview', productOps);
    url.searchParams.set('publication', publication);
    url.searchParams.set('locale', locale.value);
    url.searchParams.set('discovery', discoveryScene);
    url.searchParams.set('state', state.value);
    frame.src = url.href;
  };
  for (const select of [locale, state]) select.addEventListener('change', open);
  const fail = (message, showLogin) => { setToolsOpen(false); root.classList.remove('is-ready'); status.textContent = message; controls.hidden = true; frame.hidden = true; login.hidden = !showLogin; if (tools) tools.hidden = true; };
  async function bootstrap() {
    if (!/^sp_[a-f0-9-]{36}$/.test(publication)) { fail(labels.closed, false); return; }
    try {
      const nonce = crypto.randomUUID();
      const identityResponse = await fetch(`/tools/collection-access/sales?sales_nonce=${encodeURIComponent(nonce)}`, { credentials: 'same-origin', cache: 'no-store' });
      const identity = await identityResponse.json();
      if (!identityResponse.ok || !identity?.ok || !identity.assertion) { fail(labels.denied, true); return; }
      const exchangeResponse = await fetch(`${productOps}/sales/auth/exchange`, { method: 'POST', credentials: 'include', cache: 'no-store', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ assertion: identity.assertion, nonce }) });
      const session = await exchangeResponse.json();
      if (!exchangeResponse.ok || !session?.ok || !['sales_owner', 'sales_preview'].includes(session.role) || !session.token) { fail(labels.denied, false); return; }
      const check = await fetch(`${productOps}/sales/preview/publication?id=${encodeURIComponent(publication)}`, { headers: { Authorization: `Bearer ${session.token}` }, credentials: 'include', cache: 'no-store' });
      if (!check.ok) { fail(labels.denied, false); return; }
      status.textContent = labels.ready;
      root.classList.add('is-ready');
      controls.hidden = false;
      frame.hidden = false;
      if (tools) tools.hidden = false;
      open();
    } catch { fail(labels.retry, false); }
  }
  bootstrap();
})();
